module.exports = __webpack_public_path__ + "img/desk2.0d9c9b27.png";